// src/store/api/providerApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const providerApi = createApi({
  reducerPath: "providerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "users/provider",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    updateProvider: builder.mutation({
      query: ({
        providerId,
        fullname,
        email,
        nationalCode,
        gender,
        birthDay,
        profileImg,
        skills,
        serviceCategories,
        description,
        bannerImg,
        bankInfo = {},
      } = {}) => {
        const payload = {};
        if (fullname != null) payload.fullname = fullname;
        if (email != null) payload.email = email;
        if (gender != null) payload.gender = gender;
        if (nationalCode != null) payload.nationalCode = nationalCode;
        if (bankInfo != null) payload.bankInfo = bankInfo;
        if (birthDay != null) payload.birthDay = birthDay;
        if (profileImg != null) payload.profileImg = profileImg;
        if (skills != null) payload.skills = skills;
        if (serviceCategories != null) payload.serviceCategories = serviceCategories;
        if (bannerImg != null) payload.bannerImg = bannerImg;
        if (description != null) payload.description = description;
        return {
          url: `/${providerId}`,
          method: "PATCH",
          body: payload,
        };
      },
    }),
    getProvidersByRank: builder.query({
      query: (query = {}) => {
        const { page = 1, limit = 10 } = query;
        let url = `/top?page=${page}&limit=${limit}`;
        return { url, method: "GET" };
      },
    }),
    getProviders: builder.query({
      query: (query = {}) => {
        const { sort, filter, page = 1, limit = 10, id, search } = query;
        let url = `/front?page=${page}&limit=${limit}`;
        if (filter) url += `&filter=${filter}`;
        return { url, method: "GET" };
      },
    }),
    getOneProvider: builder.query({
      query: ({ id }) => ({ url: `/${id}`, method: "GET" }),
    }),
    // ✅ New endpoint: get providers by category
    getProvidersByCategory: builder.query({
      query: (categoryId) => ({
        url: `/category/${categoryId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useUpdateProviderMutation,
  useGetProvidersByRankQuery,
  useGetProvidersQuery,
  useGetOneProviderQuery,
  useLazyGetOneProviderQuery,
  useGetProvidersByCategoryQuery, // ✅ export new hook
} = providerApi;